export default {
  estimates: {
    addProfile: 'Wybierz profil do dodania',
    selectProfile: 'Wybierz profil',
    selectMonth: 'Wybierz miesiąc',
    select: 'Proszę wskazać',
    noPositionSelected: 'Nie wybrano żadnych pozycji do importowania.',
    selectPositionsToImport: 'Wskaż pozycje do importowania na miesiąc',
    filterByProfile: 'Filtruj po profilu',
    filterByMonth: 'Filtruj po miesiącu',
    filterByPhase: 'Filtruj po fazie',
    positionAccusative1: 'pozycję',
    positionAccusative2_4: 'pozycje',
    positionAccusative5: 'pozycji',
    importSelected: 'Importuj zaznaczone',
    importAll: 'Importuj wszystkie',
    withoutAmounts: 'Bez kwot',
    withAmounts: 'Z kwotami',
    clone: 'Klonuj',
    cloneSelectedEstimateByMonth: 'Klonuj wskazany profil na wybrany miesiąc',
    cloneEstimateByMonth: 'Klonuj miesięczny profil',
    saveStatus: 'Zapisz status',
    sales: 'Sprzedaż',
    purchase: 'Zakup',
    fvz: 'FVZ',
    fvs: 'FVS',
    fvzDiff: 'Różnica FVZ',
    margin: 'Marża',
    orderNumber: 'Nr zlecenia',

    noPositions: 'Brak pozycji do wyświetlenia.',
    month: 'Miesiąc',
    profile: 'Profil',
    parameters: 'Parametry',
    salesNetTotal: 'Netto sprzedaż total',
    purchaseNetTotal: 'Netto zakup total',
    positionName: 'Nazwa pozycji',
    positionCountry: 'Kraj/rynek',
    positionPhase: 'Faza',
    deliveryTeam: 'Zespół realizujący',
    positionPathPhaseTooltip:
      'Faza klienta, na którym etapie lejka działa dana pozycja: <strong>Trigger</strong> (impuls / zasięg), <strong>Explore</strong> (rozważanie), <strong>Convert</strong> (sprzedaż / performance), <strong>Retain</strong> (utrzymanie klienta). Służy do grupowania i raportowania działań według etapu fazy. ',
    amountToInvoice: 'Kwota do zafakturowania',
    amountToAccept: 'Kwota do zaakceptowania',

    globalSalesBlockade: 'Aktywna globalna blokada sprzedaży w miesiącu',
    globalPurchaseBlockade: 'Aktywna globalna blokada zakupu w miesiącu',
    addPosition: 'Dodaj pozycję',
    saveAddedPosition: 'Proszę zapisać dodaną wcześniej pozycję.',
    category: 'Kategoria',
    amounts: 'Kwoty',

    lastPositionModification: 'Ostatnia modyfikacja pozycji przez mediaplanera',
    deletePositionConfirmation: 'Czy na pewno usunąć widoczną pozycję?',
    deletePosition: 'Usuń pozycję',
    deleteNewPosition: 'Usuń nową pozycję',
    saveChanges: 'Zapisz zmiany',
    saveNewPosition: 'Zapisz nową pozycję',
    summary: 'Podsumowanie',
    positions: 'Pozycje',
    status: 'Status',
    applications: 'Wnioski',
    askDeleteProfile: 'Czy na pewno usunąć miesięczny profil?',
    deleteProfile: 'Usuń miesięczny profil',
    selectTargetMonth:
      'Proszę wskazać miesiąc docelowy (↑do wskazania na górze okienka↑).',
    addMonth: 'Dodaj miesiąc',
    importPositionFrom: 'Importuj pozycje z',

    //PAE
    paeImport: 'Import z PAE',
    openInPae: 'Otwórz w PAE',
    refreshData: 'Odśwież dane',
    paeImportWarning:
      'Uwaga. Importowany będzie tylko zakup -  sprzedaż nie zaimportuje się, ponieważ jest blokada sprzedaży na profilu.',
    purchaseForm: 'Forma zakupu',
    paePurchaseForm: 'Format z PAE',
    paePositionNumber: 'Nr pozycji z PAE',
    comment: 'Komentarz',
    actionGroup: 'Grupa działań',
    paePositionNotReadyToImport: `Pozycja: (nazwa: {{name}}, nr z PAE: {{number}}, kwota: {{amount}}) jest niekompletna. Brak informacji o: {{missingFields}}.`,
    paePositionImportErrors: 'Błędy podczas importu pozycji z PAE.',
    paePositionImportErrorsDescription:
      'Proszę uzupełnić błędne pozycje lub ich nie importować:',

    issueDate: 'Data wystawienia',
    sellDate: 'Data sprzedaży',
    invoiceAmount: 'Kwota faktury',
    settledAmount: 'Kwota rozliczona',
    lastModification: 'Ostatnia modyfikacja',
    attachment: 'Załącznik',
    payments: 'Wpłaty',
    noFVZAssigned: 'Brak przypisanych faktur zakupu',

    noFVS: 'Brak wystawionych faktur sprzedaży',
    profileSalesBlockade: 'Aktywna blokada sprzedaży na profilu',
    profilePurchaseBlockade: 'Aktywna blokada zakupu na profilu',
    changeStatus: 'Czy na pewno zmienić status?',
    purchaseAmount: 'Kwota zakupu',
    noPositionsAssigned: 'Brak pozycji przypisanych do tego zespołu.',
    positionMonth: 'Miesiąc pozycji',
    positionStartDate: 'Data rozpoczęcia pozycji',
    positionEndDate: 'Data zakończenia pozycji',
    invoiceInstruction: 'Instrukcje fakturowania',
    newUnwritten: 'Nowa pozycja (NIEZAPISANA)',
    invoiced: 'Zafakturowano',
    accepted: 'Zaakceptowano',
    fillField: 'Proszę uzupełnić pole',
    choosePathPhase: 'Proszę wybrać fazę.',
    chooseDeliveryTeam: 'Proszę wybrać zespół realizujący.',
    noFitDeliveryTeamToPosition:
      'Wybrany zespół realizujący nie należy do zespołów zdefiniowanych do obsługi danej pozycji.',
    noFitDeliveryTeamToPathPhase:
      'Wybrany zespół realizujący obsługuje fazę "{{phase}}", niezgodną z fazą wybraną w pozycji kampanii.',
    alertAmountSum100:
      'Kwoty procentowe muszą sumować się do 100%. Aktualnie suma to {{sum}}%',
    billed: 'Fakturujący (kontrahent)',
    deletedPosition: `Pozycja profilu '{{position}}' została oznaczona jako nieaktywna w systemie. Nie można jej klonować`,
    selectParameter: 'Wybierz parametr',
    chooseParam: 'Wybór parametru',
    changeParam: 'Zmień parametr',
    chooseParamToUpdate: 'Wybór parametru do zmiany',
    deleteActionGroup: '[Usuń wybraną grupę]',
    nameFromDictionary: 'Nazwa z słownika',
    lack: 'Brak',
    technicalCostAbbreviation: 'KT',
    commissionAbbreviation: 'P',
    transferredCommissionAbbreviation: 'PT',
    ball: 'Produkt',
    ballTooltip:
      'Produkt to nasza „Kulka”, a każda „Kulka” reprezentuje konkretny produkt lub usługę.',
  },

  projects: {
    for: 'Dla',
    from: 'Od',
    to: 'Do',
    leadTeam: 'Zespół prowadzący',
    dateRange: 'Zakres dat',
    parameters: 'Parametry',
    summary: 'Podsumowanie',
    orders: 'Zamówienia',
    ordersExecution: 'Realizacja zamówień',
    documents: 'Dokumenty',
    fvz: 'FVZ',
    fvzUnsettled: 'FVZ nierozliczone',
    fvs: 'FVS',
    services: 'Usługi',
    cancelRequestApproved: 'wniosek o anulowanie został zatwierdzony',
    country: 'Kraj/rynek',
    pathPhases: 'Fazy',
    purchaserDocNumber: 'Numer dokumentu klienta',
    note: 'Notatka',
    documentsControl: 'Kontrola dokumentów',
    cancelApplication: 'Wniosek o anulowanie',
    edit: 'Edycja',
    cancelApplicationSubmitted:
      'Dla {{project}} został złożony wniosek o anulowanie {{project}}.',
    dateChangeApplicationSubmitted:
      'Dla {{project}} został złożony wniosek o zmianę dat. Nowe daty to: {{startDate}} - {{endDate}}.',
    cancelVerificationWaiting: 'Czeka na weryfikację wniosku o anulowanie',
    dateChangeVerificationWaiting: 'Czeka na weryfikację wniosku o zmianę dat',
    clone: 'Klonuj',
    withoutAmounts: 'Bez kwot',
    withAmounts: 'Z kwotami',
    applicationVerificationWaiting: 'Czeka na weryfikację wniosku',
    attachments: 'Załączniki',
    cancelReason: 'Powód anulowania',
    fillCancelReason: 'Proszę uzupełnić powód anulowania',
    saveApplication: 'Zapisz wniosek',
    createApplication: 'Utwórz wniosek',
    askRemoveApplication: 'Czy na pewno usunąć wniosek?',
    deleteApplication: 'Usuń wniosek',
    applicationContent: 'Treść wniosku',
    sendApplication: 'Wyślij wniosek',
    salesNet: 'Netto sprzedaż',
    salesCommissionAmount: 'Prowizja sprzedaż',
    salesTotal: 'Total sprzedaż',
    salesInvoicesSum: 'Suma FVS',
    purchaseTotal: 'Total Zakup',
    purchaseInvoicesSum: 'Suma FVZ',
    margin: 'Marża',
    salesLock: 'Blokada sprzedaż',
    purchaseLock: 'Blokada zakup',
    purchaseDiff: 'Różnica zakup',
    noPositions: 'Brak pozycji',
    invoicesNumber: 'Numery faktur',
    activeProfiles: 'Aktywne profile',
    client: 'Kontrahent',
    salesInvoicesAmount: 'FVS netto',
    salesDiff: 'Różnica sprzedaż',
    purchaseInvoicesAmount: 'FVZ netto',
    complianceWithSalesTotal: 'Zgodność realizacji z total sprzedaż',
    parentNumber: 'Nr zlecającego',
    sales: 'Sprzedaż',
    costs: 'Koszty',
    action: 'Działanie',
    specialInvoicingApplication: 'Utwórz wniosek o niestandardowe fakturowanie',
    editMonthBlockade: 'Edycja blokady miesięcznej',
    addMonthBlockade: 'Dodawanie nowej blokady miesięcznej',
    salesBlockade: 'Blokada sprzedaży',
    purchaseBlockade: 'Blokada zakupu',
    salesUnblockade: 'Odblokowanie sprzedaży',
    purchaseUnblockade: 'Odblokowanie zakupu',
    noBlockades: 'Brak blokad miesięcznych w systemie.',
    noBlockadesExceptions: 'Brak wyjątków blokad miesięcznych w systemie.',
    daysAfterDeadline: 'Liczba dni po terminie',
    toClarify: 'Do wyjaśnienia',
    commentMediaPlanner: 'Komentarz mediaplanera',
    commentFinance: 'Komentarz finanse',
    label: 'Etykieta',
    noFVZLack: 'Brak braków FVZ w systemie',
    monthBlockades: 'Blokady miesięczne',
    newMonthBlockade: 'Nowa blokada miesięczna',
    globalBlockades: 'Globalne blokady',
    exceptionBlockades: 'Wyjątki od założonych blokad globalnych',
    historyExceptionBlockades: 'Historia wyjątków blokad',
    viewMonthBlockadeException: 'Podgląd wyjątku blokady globalnej',
    editMonthBlockadeException: 'Edycja wyjątku blokady globalnej',
    addMonthBlockadeException: 'Dodawanie nowego wyjątku blokady globalnej',
    newMonthUnblockade: 'Nowy wyjątek',
    askDeleteBlockade: 'Czy na pewno usunąć globalną blokadę miesięczną?',
    askDeleteBlockadeException:
      'Czy na pewno usunąć wyjątek od globalnej blokady miesięcznej?',

    approved: 'Zatwierdzony',
    rejected: 'Odrzucony',
    waited: 'Oczekujący',
    dateToDeleteBlockade: 'Data automatycznego usunięcia wyjątku',
    addExceptionReason: 'Przyczyna',
    byProfiles: 'Wg profili',
    byPublishers: 'Wg dostawców',
    copyNumberToClipboard: 'Kopiuj numer do schowka',
  },
  contract: {
    contractHasPositionContractNotRequired:
      'Zlecenie zawiera pozycje, które nie wymagają zlecenia: {{positions}}. Nie można go przekazać do podpisu ani podpisać.',
    tv: 'Zlecenie TV',
    contractSystemNumber: 'Zlecenie o nr sys.',
    contractNew: 'Dodawanie nowego zlecenia',
    contractNewFromFile: 'Dodawanie nowego zlecenia z pliku na dysku',
    contractNewTvFromFile: 'Dodawanie nowego zlecenia tv z pliku na dysku',
    noContracts: 'Brak zleceń do wyświetlenia.',
    contracts: 'Zlecenia',
    contractsToSign: 'Podpisywanie zleceń',
    contract: 'Zlecenie',
    all: 'Wszystkie',
    entered: 'Moje wprowadzone',
    waitingForSigning: 'Oczekujące na podpisanie',
    signedNotSent: 'Podpisane, niewysłane',
    unsigned: 'Odmowa podpisania',
    waitingToSignFromMe: 'Oczekujące na podpisanie przeze mnie',
    signByMe: 'Wszystkie',
    authorizedPerson: 'Osoba upoważniona',
    general: 'Dane podstawowe',
    contractorLabel: 'Zleceniobiorca (Dostawca)',
    amountLabel: 'Kwota zlecenia',
    numberLabel: 'Numer zlecenia',
    fileLabel: 'Plik zlecenia (PDF)',
    additionalEmailContent: 'Dodatkowa treść e-maila',
    notSendAutomatically: 'Nie wysyłaj automatycznie',
    signedOutsidePokLabel: 'Podpisany poza POK',
    positions: 'Pozycje',
    contractorEmail: 'E-mail zleceniobiorcy',
    contractorLanguage: 'Język komunikacji z kontrahentem',
    stepForward: 'Dalej',
    saveAndStepForward: 'Zapisz i przejdź dalej',
    sendToSigning: 'Przekaż do podpisu',
    markAsSigned: 'Oznacz jako podpisany',
    askDeleteContract: 'Czy na pewno usunąć zlecenie?',
    askUpdateContract: 'Czy na pewno chcesz zaktualizować zlecenie?',
    nip: 'NIP',
    unwrittenUppercase: 'NIEZAPISANE',
    notAssignedAmount: 'Nieprzypisana kwota',
    fillAllFields: 'Wypełnij wszystkie widoczne pola kwotą nierozliczoną',
    fillNotAssignedAmount: 'Wypełnij kwotą nierozliczoną',
    contractAmountUppercase: 'KWOTA ZLECENIA',
    unsettledAmountUppercase: 'KWOTA NIEPRZYPISANA',
    unsettledAmount: 'Kwota  nieprzypisana',
    showSettled: 'Pokaż pozycje z całkowicie dowiązanymi zleceniami',
    sumExceedsContractAmount:
      'Suma kwot zapisanych przypisań, przekracza kwotę całkowitą zlecenia.',
    hideAttachment: 'Ukryj załącznik',
    showAttachment: 'Pokaż załącznik',
    warningChangeSupplierOrProject:
      'Pola „{{project}}” i „{{contractor}}” są zablokowane, ponieważ na zakładce „{{tab}}” przypisano już kwoty. Aby móc zmieniać te pola, najpierw usuń kwoty na zakładce „{{tab}}”.',
    selectToUpdate: 'Wybierz zlecenie do aktualizacji',
    warningSelectToUpdate:
      'Uwaga: należy wybrać zlecenie, które ma zostać zaktualizowane. Do wybranego zlecenia zostanie wstawiony załącznik z obecnie przetwarzanego zlecenia, które jednocześnie zostanie automatycznie usunięte.',

    askSigningContracts: 'Czy na pewno podpisać zlecenia?',
    signAllContracts: 'Podpisz wszystkie zlecenia',
    signContracts: 'Podpisz zaznaczone zlecenia ({{number}} szt.)',
    signContract: 'Podpisz',
    sentByHand: 'Oznacz jako wysłane',
    unsignContract: 'Odmowa podpisania',
    selected: 'zaznaczone',
    contractRejection: 'Odmowa podpisania zlecenia',
    rejectionContractReason: 'Powód odmowy',
    rejectContract: 'Odmów podpisania',
    fillRejectionReason: 'Proszę uzupełnić powód odmowy podpisania zlecenia.',
    askSentByHandsContract: 'Czy na pewno zlecenie zostało wysłane?',
    sentOutOfSystem: 'Zlecenie zostało wysłane poza systemem.',
    monthFilter: 'Filtruj po miesiącu',
    signDate: 'Data podpisania',
    unsignDate: 'Data odmowy podpisania',
    waitingForSigningDate: 'Data przekazania do podpisu',
    hasNegativeAmounts:
      'Kwota dowiązania ze zlecenia przekracza kwotę pozycji {{estimate}}. Czy na pewno zapisać zlecenie?',
    hasMoreThenAvailableAmounts:
      'Kwota dowiązania ze zlecenia przekracza nieprzypisaną kwotę pozycji {{estimate}}. Czy na pewno zapisać zlecenie?',
    signingInProgress: 'Proszę czekać, trwa podpisywanie zleceń...',
  },

  timeLine: {
    selectMonth: 'Wybierz miesiąc',
    all: 'Wszystkie',
    title: 'Oś czasu',
    month: 'Miesiąc',
    refresh: 'Odśwież',
    profile: 'Profil',
    stageDetails: 'Szczegóły etapu',
    stage: 'Etap',
    checklist: 'CHECKLISTA',
    errors: 'Błędy',
    hints: 'WSKAZÓWKI',
    auto: 'Auto',
    requiresAttention: 'UWAGI',
    information: 'INFORMACJE',
    requestInfo: 'WNIOSKI',
    allClear: 'Wszystko w porządku',
    newHint: 'Nowa wskazówka',
    editHint: 'Edytuj wskazówkę',
    addHint: 'Dodaj wskazówkę',
    hintText: 'Treść wskazówki',
    order: 'Kolejność',
    hintTextEn: 'Treść wskazówki w j. angielskim',
    url: 'URL',
    deadline: 'Termin wykonania',
    deadlineWithTime: 'Termin wykonania: {{deadline}}',
    noHints: 'Brak wskazówek do wyświetlenia.',
    timeLineHints: 'Wskazówki dla etapów na osi czasu',
    stageOnTimeline: 'Etap na osi czasu',
    description: 'Opis',
    descriptionEn: 'Opis w j. angielskim',
    linkInSystem: 'Link w systemie',
    automatic: 'Automatyczna',
    showInChecklist: 'Pokaż na checkliście',
    priority: 'Priorytet',
    timeLineSteps: 'Lista wszystkich zdefiniowanych kroków',
    collapse: 'Zwiń',
    expand: 'Rozwiń',
    manual: 'Manual',
    future: 'NADCHODZĄCE',
  },
} as const;
